import Main from './WithdrawsMain'

const Withdraws = {
  Main,
}

export default Withdraws
